<div class="panel__header">
  <div>
    <h2>{{ 'admin.overview.title' | adminTranslate }}</h2>
  </div>
  <button
    type="button"
    class="btn-icon btn-icon-refresh"
    (click)="loadOverview(); loadSiteAnalytics()"
    [disabled]="loading"
    [title]="'admin.common.refresh' | adminTranslate"
    [attr.aria-label]="'admin.common.refresh' | adminTranslate">
    <ui-icon name="refresh"></ui-icon>
  </button>
</div>

@if (overview; as data) {
  @if (!isMonitoringMode) {
    <div class="kpi-grid">
      <a class="kpi-card" [routerLink]="['/users']">
        <span>{{ 'admin.overview.users' | adminTranslate }}</span>
        <strong>{{ data.totalUsers }}</strong>
      </a>
      <a class="kpi-card" [routerLink]="['/users']">
        <span>{{ 'admin.overview.admins' | adminTranslate }}</span>
        <strong>{{ data.adminUsers }}</strong>
      </a>
      <a class="kpi-card" [routerLink]="['/users']">
        <span>{{ 'admin.overview.supportUsers' | adminTranslate }}</span>
        <strong>{{ data.supportUsers }}</strong>
      </a>
      <a class="kpi-card" [routerLink]="['/support']">
        <span>{{ 'admin.overview.activeSessions' | adminTranslate }}</span>
        <strong>{{ data.activeSupportSessions }}</strong>
      </a>
      <a class="kpi-card" [routerLink]="['/audit']" [queryParams]="{ success: 'false' }">
        <span>{{ 'admin.overview.failedAudit' | adminTranslate }}</span>
        <strong>{{ data.failedAuditEvents }}</strong>
      </a>
      <a class="kpi-card" [routerLink]="['/audit']">
        <span>{{ 'admin.overview.linkedTwitch' | adminTranslate }}</span>
        <strong>{{ data.linkedTwitchAccounts }}</strong>
      </a>
      <a class="kpi-card" [routerLink]="['/audit']">
        <span>{{ 'admin.overview.linkedDiscord' | adminTranslate }}</span>
        <strong>{{ data.linkedDiscordAccounts }}</strong>
      </a>
      <a class="kpi-card" [routerLink]="['/audit']">
        <span>{{ 'admin.overview.linkedSpotify' | adminTranslate }}</span>
        <strong>{{ data.linkedSpotifyAccounts }}</strong>
      </a>
    </div>

    <div class="section-block">
      <div class="section-block__header">
        <div>
          <h3>{{ 'admin.overview.chatAnalyticsRecalculationTitle' | adminTranslate }}</h3>
          <p class="section-caption">{{ 'admin.overview.chatAnalyticsRecalculationCaption' | adminTranslate }}</p>
        </div>
        <ui-button
          variant="secondary"
          size="sm"
          [disabled]="chatAnalyticsRecalculationLoading || isChatAnalyticsRecalculationRunning"
          (click)="startChatAnalyticsRecalculation()">
          {{ (isChatAnalyticsRecalculationRunning ? 'admin.overview.chatAnalyticsRecalculationRunning' : 'admin.overview.chatAnalyticsRecalculationStart') | adminTranslate }}
        </ui-button>
      </div>

      <div class="analytics-recalculation-card">
        <div class="analytics-recalculation-card__meta">
          <span>{{ 'admin.overview.chatAnalyticsRecalculationStatusLabel' | adminTranslate }}</span>
          <strong>{{ chatAnalyticsRecalculationStatusLabel(chatAnalyticsRecalculation?.status) }}</strong>
        </div>
        <div class="analytics-recalculation-card__progress" aria-hidden="true">
          <span [style.width.%]="chatAnalyticsRecalculationProgress"></span>
        </div>
        <div class="analytics-recalculation-card__grid">
          <span>{{ 'admin.overview.chatAnalyticsRecalculationProcessed' | adminTranslate:{ processed: chatAnalyticsRecalculation?.processedSessions || 0, total: chatAnalyticsRecalculation?.totalSessions || 0 } }}</span>
          <span>{{ 'admin.overview.chatAnalyticsRecalculationRefreshed' | adminTranslate:{ count: chatAnalyticsRecalculation?.refreshedSessions || 0 } }}</span>
          <span>{{ 'admin.overview.chatAnalyticsRecalculationFailed' | adminTranslate:{ count: chatAnalyticsRecalculation?.failedSessions || 0 } }}</span>
        </div>
        @if (chatAnalyticsRecalculation?.lastError) {
          <p class="analytics-recalculation-card__error">{{ chatAnalyticsRecalculation?.lastError }}</p>
        }
      </div>
    </div>

    <div class="section-block">
      <div class="section-block__header">
        <div>
          <h3>{{ 'admin.overview.levelRecalculationTitle' | adminTranslate }}</h3>
          <p class="section-caption">{{ 'admin.overview.levelRecalculationCaption' | adminTranslate }}</p>
        </div>
        <ui-button
          variant="secondary"
          size="sm"
          [disabled]="levelRecalculationLoading || isLevelRecalculationRunning"
          (click)="startLevelRecalculation()">
          {{ (isLevelRecalculationRunning ? 'admin.overview.levelRecalculationRunning' : 'admin.overview.levelRecalculationStart') | adminTranslate }}
        </ui-button>
      </div>

      <div class="analytics-recalculation-card">
        <label class="level-recalculation-field">
          <span>{{ 'admin.overview.levelRecalculationUserId' | adminTranslate }}</span>
          <ui-input
            [(ngModel)]="levelRecalculationUserId"
            size="sm"
            [placeholder]="'admin.overview.levelRecalculationUserIdPlaceholder' | adminTranslate">
          </ui-input>
        </label>
        @if (levelRecalculation) {
          <div class="analytics-recalculation-card__meta">
            <span>{{ 'admin.overview.chatAnalyticsRecalculationStatusLabel' | adminTranslate }}</span>
            <strong>{{ levelRecalculationStatusLabel(levelRecalculation.status) }}</strong>
          </div>
          <div class="analytics-recalculation-card__progress" aria-hidden="true">
            <span [style.width.%]="levelRecalculationProgress"></span>
          </div>
          <div class="analytics-recalculation-card__grid">
            <span>{{ 'admin.overview.levelRecalculationProcessed' | adminTranslate:{ processed: levelRecalculation.processedUsers || 0, total: levelRecalculation.totalUsers || 0 } }}</span>
            <span>{{ 'admin.overview.levelRecalculationUpdated' | adminTranslate:{ count: levelRecalculation.recalculatedUsers || 0 } }}</span>
            <span>{{ 'admin.overview.levelRecalculationErrors' | adminTranslate:{ count: levelRecalculation.failedUsers || 0 } }}</span>
          </div>
          @if (levelRecalculation.currentUserId) {
            <p class="analytics-recalculation-card__hint">{{ 'admin.overview.levelRecalculationCurrentUser' | adminTranslate:{ userId: levelRecalculation.currentUserId } }}</p>
          }
          @if (levelRecalculation.lastError) {
            <p class="analytics-recalculation-card__error">{{ levelRecalculation.lastError }}</p>
          }
        }
      </div>
    </div>

    <div class="section-block">
      <div class="section-block__header">
        <div>
          <h3>{{ 'admin.overview.followersSyncTitle' | adminTranslate }}</h3>
          <p class="section-caption">{{ 'admin.overview.followersSyncCaption' | adminTranslate }}</p>
        </div>
        <ui-button
          variant="secondary"
          size="sm"
          [disabled]="twitchFollowerSyncLoading || isTwitchFollowerSyncRunning"
          (click)="startTwitchFollowerSync()">
          {{ (isTwitchFollowerSyncRunning ? 'admin.overview.followersSyncRunning' : 'admin.overview.followersSyncStart') | adminTranslate }}
        </ui-button>
      </div>

      <div class="analytics-recalculation-card">
        @if (twitchFollowerSync) {
          <div class="analytics-recalculation-card__meta">
            <span>{{ 'admin.overview.chatAnalyticsRecalculationStatusLabel' | adminTranslate }}</span>
            <strong>{{ twitchFollowerSyncStatusLabel(twitchFollowerSync.status) }}</strong>
          </div>
          <div class="analytics-recalculation-card__progress" aria-hidden="true">
            <span [style.width.%]="twitchFollowerSyncProgress"></span>
          </div>
          <div class="analytics-recalculation-card__grid">
            <span>{{ 'admin.overview.followersSyncProcessed' | adminTranslate:{ processed: twitchFollowerSync.processedUsers || 0, total: twitchFollowerSync.totalUsers || 0 } }}</span>
            <span>{{ 'admin.overview.followersSyncFetched' | adminTranslate:{ count: twitchFollowerSync.fetchedFollowers || 0 } }}</span>
            <span>{{ 'admin.overview.followersSyncErrors' | adminTranslate:{ count: (twitchFollowerSync.errors || []).length } }}</span>
          </div>
          @if (twitchFollowerSync.currentUserId) {
            <p class="analytics-recalculation-card__hint">{{ 'admin.overview.followersSyncCurrentUser' | adminTranslate:{ userId: twitchFollowerSync.currentUserId } }}</p>
          }
          @if (twitchFollowerSync.deactivatedFollowers) {
            <p class="analytics-recalculation-card__hint">{{ 'admin.overview.followersSyncDeactivated' | adminTranslate:{ count: twitchFollowerSync.deactivatedFollowers } }}</p>
          }
          @if (twitchFollowerSync.lastError) {
            <p class="analytics-recalculation-card__error">{{ twitchFollowerSync.lastError }}</p>
          }
        }
      </div>
    </div>

    <div class="section-block">
      <div class="section-block__header">
        <div>
          <h3>{{ 'admin.overview.analyticsTitle' | adminTranslate }}</h3>
          <p class="section-caption">{{ 'admin.overview.analyticsCaption' | adminTranslate }}</p>
        </div>
      </div>

      @if (siteAnalytics; as analytics) {
        <div class="analytics-kpi-grid">
          <article class="infra-summary__card">
            <span class="metric-label">{{ 'admin.overview.analyticsViews' | adminTranslate }}</span>
            <strong>{{ analytics.totalPageViews }}</strong>
          </article>
          <article class="infra-summary__card">
            <span class="metric-label">{{ 'admin.overview.analyticsVisitors' | adminTranslate }}</span>
            <strong>{{ analytics.totalUniqueVisitors }}</strong>
          </article>
          <article class="infra-summary__card">
            <span class="metric-label">{{ 'admin.overview.analyticsActions' | adminTranslate }}</span>
            <strong>{{ analytics.totalActionCount }}</strong>
          </article>
          <article class="infra-summary__card">
            <span class="metric-label">{{ 'admin.overview.analyticsAvgTime' | adminTranslate }}</span>
            <strong>{{ formatDurationSeconds(analytics.averageTimeSeconds) }}</strong>
          </article>
        </div>

        <div class="analytics-grid">
          <article class="analytics-card">
            <h4>{{ 'admin.overview.analyticsTimeline' | adminTranslate }}</h4>
            <div class="analytics-timeline">
              @for (point of analytics.dailyTimeline; track point.date) {
                <div class="analytics-timeline__row">
                  <span class="analytics-timeline__date">{{ point.date }}</span>
                  <div class="analytics-timeline__bar">
                    <span class="analytics-timeline__fill" [style.width.%]="analyticsTimelineWidth(point)"></span>
                  </div>
                  <span class="analytics-timeline__value">{{ point.pageViews }}</span>
                </div>
              }
            </div>
          </article>

          <article class="analytics-card">
            <h4>{{ 'admin.overview.analyticsTopPages' | adminTranslate }}</h4>
            <div class="analytics-list">
              @for (page of analyticsTopPages; track page.pageKey) {
                <div class="analytics-list__item">
                  <strong>{{ analyticsLabel(page.pageKey) }}</strong>
                  <small>{{ 'admin.overview.analyticsTopPagesMeta' | adminTranslate:{ views: page.pageViews, visitors: page.uniqueVisitors, time: formatDurationSeconds(page.averageTimeSeconds) } }}</small>
                </div>
              }
            </div>
          </article>

          <article class="analytics-card">
            <h4>{{ 'admin.overview.analyticsTopActions' | adminTranslate }}</h4>
            <div class="analytics-list">
              @for (action of analyticsTopActions; track action.pageKey + action.actionKey) {
                <div class="analytics-list__item">
                  <strong>{{ analyticsLabel(action.actionKey) }}</strong>
                  <small>{{ 'admin.overview.analyticsTopActionsMeta' | adminTranslate:{ page: analyticsLabel(action.pageKey), count: action.eventCount, visitors: action.uniqueVisitors } }}</small>
                </div>
              }
            </div>
          </article>

          <article class="analytics-card">
            <h4>{{ 'admin.overview.analyticsTopTransitions' | adminTranslate }}</h4>
            <div class="analytics-list">
              @for (transition of analyticsTopTransitions; track transition.fromPageKey + transition.toPageKey) {
                <div class="analytics-list__item">
                  <strong>{{ analyticsLabel(transition.fromPageKey) }} {{ 'admin.overview.analyticsTransitionArrow' | adminTranslate }} {{ analyticsLabel(transition.toPageKey) }}</strong>
                  <small>{{ 'admin.overview.analyticsTopTransitionsMeta' | adminTranslate:{ count: transition.transitionCount, visitors: transition.uniqueVisitors } }}</small>
                </div>
              }
            </div>
          </article>
        </div>
      } @else {
        <p class="empty">{{ 'admin.overview.analyticsEmpty' | adminTranslate }}</p>
      }

      @if (twitchModerationAnalytics; as moderationAnalytics) {
        <div class="section-block__header">
          <div>
            <h3>Moderation Twitch</h3>
            <p class="section-caption">Actions automatiques du bot sur les 14 derniers jours.</p>
          </div>
        </div>

        <div class="analytics-kpi-grid">
          <article class="infra-summary__card">
            <span class="metric-label">Actions</span>
            <strong>{{ moderationAnalytics.totalActions }}</strong>
          </article>
          <article class="infra-summary__card">
            <span class="metric-label">Succes</span>
            <strong>{{ moderationAnalytics.successfulActions }}</strong>
          </article>
          <article class="infra-summary__card">
            <span class="metric-label">Echecs</span>
            <strong>{{ moderationAnalytics.failedActions }}</strong>
          </article>
          <article class="infra-summary__card">
            <span class="metric-label">Actions follow bots</span>
            <strong>{{ moderationAnalytics.botProtectionSummary.followBotActions }}</strong>
          </article>
          <article class="infra-summary__card">
            <span class="metric-label">Follow bots stoppes</span>
            <strong>{{ moderationAnalytics.botProtectionSummary.followBotsStopped }}</strong>
          </article>
          <article class="infra-summary__card">
            <span class="metric-label">Actions raid bots</span>
            <strong>{{ moderationAnalytics.botProtectionSummary.raidBotActions }}</strong>
          </article>
          <article class="infra-summary__card">
            <span class="metric-label">Raid bots stoppes</span>
            <strong>{{ moderationAnalytics.botProtectionSummary.raidBotsStopped }}</strong>
          </article>
        </div>

        <div class="analytics-grid">
          <article class="analytics-card">
            <h4>Timeline</h4>
            <ui-metric-line-chart
              title="Activite quotidienne"
              subtitle="Volume d'actions automatiques par jour"
              emptyLabel="Aucune activite"
              [showLegend]="false"
              [expandable]="false"
              [aggregationIntervalMs]="selectedModerationAggregationIntervalMs"
              [rangePickerValue]="moderationAnalyticsRangePickerValue"
              [series]="moderationTimelineChartSeries"
              (aggregationIntervalChange)="onModerationAnalyticsAggregationIntervalChange($event)"
              (rangePickerValueChange)="onModerationAnalyticsRangeChange($event)">
            </ui-metric-line-chart>
          </article>

          <article class="analytics-card">
            <h4>Top actions</h4>
            <div class="analytics-list">
              @for (action of moderationAnalytics.topActions; track action.actionType) {
                <div class="analytics-list__item">
                  <strong>{{ analyticsLabel(action.actionType) }}</strong>
                  <small>{{ action.totalActions }} actions, {{ action.failedActions }} echecs</small>
                </div>
              }
            </div>
          </article>

          <article class="analytics-card">
            <h4>Top streamers</h4>
            <div class="analytics-list">
              @for (streamer of moderationAnalytics.topStreamers; track streamer.broadcasterUserId) {
                <div class="analytics-list__item">
                  <strong>{{ streamer.channelLogin }}</strong>
                  <small>{{ streamer.totalActions }} actions, {{ streamer.failedActions }} echecs</small>
                </div>
              }
            </div>
          </article>

          <article class="analytics-card">
            <h4>Cibles recentes</h4>
            <div class="analytics-list">
              @for (event of moderationAnalytics.recentBotActions; track event.occurredAt + event.targetLogin) {
                <div class="analytics-list__item">
                  <strong>{{ event.targetLogin || 'Compte inconnu' }}</strong>
                  <small>{{ analyticsLabel(event.ruleKey) }} · {{ analyticsLabel(event.actionType) }} · {{ event.success ? 'Succes' : 'Echec' }}</small>
                  <small>{{ event.channelLogin || 'chaine inconnue' }} · {{ event.occurredAt | date:'dd/MM/yyyy HH:mm' }}</small>
                </div>
              }
            </div>
          </article>
        </div>
      }
    </div>
  } @else {
    <div class="warning-list">
      <p>{{ 'admin.overview.monitoringModeNotice' | adminTranslate }}</p>
    </div>
  }

  @if (history) {
    <div class="section-block">
      <div class="chart-grid">
        <ui-metric-line-chart
          [title]="'admin.overview.commandExecutionsChart' | adminTranslate"
          [subtitle]="'admin.overview.commandExecutionsChartHint' | adminTranslate"
          [emptyLabel]="'admin.overview.noChartData' | adminTranslate"
          [infoTooltip]="'admin.overview.helpCommandExecutionsChart' | adminTranslate"
          [valueSuffix]="'admin.overview.commandExecutionsLegend' | adminTranslate"
          [expandLabel]="'admin.overview.expandChart' | adminTranslate"
          [aggregationIntervalMs]="selectedCommandExecutionAggregationIntervalMs"
          [rangePickerValue]="commandExecutionRangePickerValue"
          [series]="commandExecutionChartSeries"
          (aggregationIntervalChange)="onCommandExecutionAggregationIntervalChange($event)"
          (rangePickerValueChange)="onCommandExecutionRangeChange($event)"
          (expandChart)="openGlobalChartModal('command-executions')">
        </ui-metric-line-chart>
      </div>
    </div>
  }

  <div class="section-block">
    <div class="section-block__header">
      <div>
        <h3>{{ 'admin.overview.infrastructureTitle' | adminTranslate }}</h3>
        <p class="section-caption">{{ 'admin.overview.infrastructureCaption' | adminTranslate }}</p>
      </div>
      <div class="history-controls">
        <div class="history-range-control-group">
          <ui-time-range-picker
            [presets]="historyRangeOptions"
            [quickPresets]="historyQuickRangeOptions"
            [value]="historyRangePickerValue"
            [labels]="timeRangePickerLabels"
            [locale]="timeRangePickerLocale"
            (valueChange)="applyHistoryRangePickerValue($event)">
          </ui-time-range-picker>
        </div>
      </div>
      @if (data.infrastructure; as infra) {
        <span [class]="infrastructureStatusClass(infra.overallStatus)">{{ infra.overallStatus }}</span>
      }
    </div>

    @if (data.infrastructure; as infra) {
      <div class="infra-summary">
        <article class="infra-summary__card">
          <span class="metric-label">
            {{ 'admin.overview.podAvailability' | adminTranslate }}
            <ui-info-tooltip class="metric-info" [text]="overviewMetricHelp('helpPodAvailability')" [label]="'admin.common.infoLabel' | adminTranslate" position="bottom"></ui-info-tooltip>
          </span>
          <strong>{{ formatPercent(podAvailabilityPercent(infra)) }}</strong>
          <small>{{ 'admin.overview.kubernetesReachable' | adminTranslate }}: {{ infra.kubernetesAvailable ? ('admin.common.ok' | adminTranslate) : ('admin.common.ko' | adminTranslate) }}</small>
        </article>
        <article class="infra-summary__card">
          <span class="metric-label">
            {{ 'admin.overview.database' | adminTranslate }}
            <ui-info-tooltip class="metric-info" [text]="overviewMetricHelp('helpDatabase')" [label]="'admin.common.infoLabel' | adminTranslate" position="bottom"></ui-info-tooltip>
          </span>
          <strong>{{ infra.database?.status || ('admin.common.notAvailable' | adminTranslate) }}</strong>
          <small>
            @if (infra.database?.latencyMs != null) {
              {{ infra.database?.latencyMs }} {{ 'admin.common.msUnit' | adminTranslate }}
            } @else {
              {{ 'admin.common.notAvailable' | adminTranslate }}
            }
          </small>
        </article>
        <article class="infra-summary__card">
          <span class="metric-label">
            {{ 'admin.overview.servicesHealth' | adminTranslate }}
            <ui-info-tooltip class="metric-info" [text]="overviewMetricHelp('helpServicesHealth')" [label]="'admin.common.infoLabel' | adminTranslate" position="bottom"></ui-info-tooltip>
          </span>
          <strong>{{ infra.services?.length || 0 }}</strong>
          <small>{{ 'admin.overview.podMetrics' | adminTranslate }}: {{ infra.podMetricsAvailable ? ('admin.common.ok' | adminTranslate) : ('admin.common.ko' | adminTranslate) }}</small>
        </article>
      </div>

      @if (visibleWarnings.length) {
        <div class="warning-list">
          @for (warning of visibleWarnings; track warning) {
            <p>{{ warning }}</p>
          }
        </div>
      }

      @if (infra.services?.length) {
        <div class="service-grid">
          @for (service of sortedInfrastructureServices; track trackService($index, service)) {
            <article class="service-card">
              <div class="service-card__header">
                <div class="service-card__heading">
                  <h4>{{ service.displayName }}</h4>
                  <div class="service-card__badges">
                    <span class="service-card__badge service-card__badge--type">{{ serviceTypeBadgeLabel(service.component) }}</span>
                    @if (serviceVersionBadgeLabel(service.version); as versionBadge) {
                      <span class="service-card__badge service-card__badge--version">{{ versionBadge }}</span>
                    }
                  </div>
                </div>
                <span [class]="infrastructureStatusClass(service.overallStatus)">{{ service.overallStatus }}</span>
              </div>
              <dl class="service-card__stats">
                <div>
                  <dt class="metric-label">
                    {{ 'admin.overview.restarts' | adminTranslate }}
                    <ui-info-tooltip class="metric-info" [text]="overviewMetricHelp('helpRestarts')" [label]="'admin.common.infoLabel' | adminTranslate" position="bottom"></ui-info-tooltip>
                  </dt>
                  <dd>{{ service.restartCount }}</dd>
                </div>
                <div>
                  <dt class="metric-label">
                    {{ 'admin.overview.serviceHealth' | adminTranslate }}
                    <ui-info-tooltip class="metric-info" [text]="overviewMetricHelp('helpServiceHealth')" [label]="'admin.common.infoLabel' | adminTranslate" position="bottom"></ui-info-tooltip>
                  </dt>
                  <dd>{{ service.actuatorStatus || ('admin.common.notAvailable' | adminTranslate) }}</dd>
                </div>
              </dl>

              <div class="service-card__charts">
                <div class="service-chart-panel">
                  <div class="service-chart-tabs" role="tablist" [attr.aria-label]="'admin.overview.podChartTabs' | adminTranslate">
                    <ui-tab
                      [label]="'admin.overview.cpu' | adminTranslate"
                      [active]="selectedServiceChartMetric(service.component) === 'cpu'"
                      [tabId]="'service-chart-' + service.component + '-cpu'"
                      (tabSelect)="setSelectedServiceChartMetric(service.component, 'cpu')">
                    </ui-tab>
                    <ui-tab
                      [label]="'admin.overview.memory' | adminTranslate"
                      [active]="selectedServiceChartMetric(service.component) === 'memory'"
                      [tabId]="'service-chart-' + service.component + '-memory'"
                      (tabSelect)="setSelectedServiceChartMetric(service.component, 'memory')">
                    </ui-tab>
                    <ui-tab
                      [label]="'admin.overview.pods' | adminTranslate"
                      [active]="selectedServiceChartMetric(service.component) === 'pods'"
                      [tabId]="'service-chart-' + service.component + '-pods'"
                      (tabSelect)="setSelectedServiceChartMetric(service.component, 'pods')">
                    </ui-tab>
                    <ui-tab
                      [label]="'admin.overview.http' | adminTranslate"
                      [active]="selectedServiceChartMetric(service.component) === 'http'"
                      [tabId]="'service-chart-' + service.component + '-http'"
                      (tabSelect)="setSelectedServiceChartMetric(service.component, 'http')">
                    </ui-tab>
                  </div>

                  <ui-metric-line-chart
                    [title]="servicePodChartTitle(service.component)"
                    [subtitle]="servicePodChartSubtitle(service.component)"
                    [emptyLabel]="'admin.overview.noChartData' | adminTranslate"
                    [infoTooltip]="servicePodChartInfoTooltip(service.component)"
                    [valueSuffix]="servicePodChartValueSuffix(service.component)"
                    [expandLabel]="'admin.overview.expandChart' | adminTranslate"
                    [series]="servicePodChartSeries(service.component)"
                    (expandChart)="openServiceChartModal(service, selectedServiceChartMetric(service.component))">
                  </ui-metric-line-chart>
                </div>
              </div>
            </article>
          }
        </div>
      }

      @if (history) {
        <div class="chart-grid">
          <ui-metric-line-chart
            [title]="'admin.overview.dbConnectionsChart' | adminTranslate"
            [subtitle]="'admin.overview.dbConnectionsChartHint' | adminTranslate"
            [emptyLabel]="'admin.overview.noChartData' | adminTranslate"
            [infoTooltip]="'admin.overview.helpDbConnectionsChart' | adminTranslate"
            [expandLabel]="'admin.overview.expandChart' | adminTranslate"
            [series]="serviceDbChartSeries"
            (expandChart)="openGlobalChartModal('db-connections')">
          </ui-metric-line-chart>

          <ui-metric-line-chart
            [title]="'admin.overview.dbPressureChart' | adminTranslate"
            [subtitle]="'admin.overview.dbPressureChartHint' | adminTranslate"
            [emptyLabel]="'admin.overview.noChartData' | adminTranslate"
            [infoTooltip]="'admin.overview.helpDbPressureChart' | adminTranslate"
            [expandLabel]="'admin.overview.expandChart' | adminTranslate"
            [series]="serviceDbPressureChartSeries"
            (expandChart)="openGlobalChartModal('db-pressure')">
          </ui-metric-line-chart>

          <ui-metric-line-chart
            [title]="'admin.overview.dbTimingChart' | adminTranslate"
            [subtitle]="'admin.overview.dbTimingChartHint' | adminTranslate"
            [emptyLabel]="'admin.overview.noChartData' | adminTranslate"
            [infoTooltip]="'admin.overview.helpDbTimingChart' | adminTranslate"
            [valueSuffix]="'admin.common.msUnitWithLeadingSpace' | adminTranslate"
            [expandLabel]="'admin.overview.expandChart' | adminTranslate"
            [series]="serviceDbTimingChartSeries"
            (expandChart)="openGlobalChartModal('db-timing')">
          </ui-metric-line-chart>

          <ui-metric-line-chart
            [title]="'admin.overview.dbLatencyChart' | adminTranslate"
            [subtitle]="'admin.overview.dbLatencyChartHint' | adminTranslate"
            [emptyLabel]="'admin.overview.noChartData' | adminTranslate"
            [infoTooltip]="'admin.overview.helpDbLatencyChart' | adminTranslate"
            [valueSuffix]="'admin.common.msUnitWithLeadingSpace' | adminTranslate"
            [expandLabel]="'admin.overview.expandChart' | adminTranslate"
            [series]="databaseLatencyChartSeries"
            (expandChart)="openGlobalChartModal('db-latency')">
          </ui-metric-line-chart>

          <ui-metric-line-chart
            [title]="'admin.overview.httpIncomingChart' | adminTranslate"
            [subtitle]="'admin.overview.httpIncomingChartHint' | adminTranslate"
            [emptyLabel]="'admin.overview.noChartData' | adminTranslate"
            [infoTooltip]="'admin.overview.helpHttpIncomingChart' | adminTranslate"
            [valueSuffix]="'admin.common.requestsPerMinuteUnit' | adminTranslate"
            [expandLabel]="'admin.overview.expandChart' | adminTranslate"
            [series]="serviceHttpIncomingChartSeries"
            (expandChart)="openGlobalChartModal('http-inbound')">
          </ui-metric-line-chart>

          <ui-metric-line-chart
            [title]="'admin.overview.httpOutgoingChart' | adminTranslate"
            [subtitle]="'admin.overview.httpOutgoingChartHint' | adminTranslate"
            [emptyLabel]="'admin.overview.noChartData' | adminTranslate"
            [infoTooltip]="'admin.overview.helpHttpOutgoingChart' | adminTranslate"
            [valueSuffix]="'admin.common.requestsPerMinuteUnit' | adminTranslate"
            [expandLabel]="'admin.overview.expandChart' | adminTranslate"
            [series]="serviceHttpOutgoingChartSeries"
            (expandChart)="openGlobalChartModal('http-outbound')">
          </ui-metric-line-chart>

          <ui-metric-line-chart
            [title]="'admin.overview.httpErrorChart' | adminTranslate"
            [subtitle]="'admin.overview.httpErrorChartHint' | adminTranslate"
            [emptyLabel]="'admin.overview.noChartData' | adminTranslate"
            [infoTooltip]="'admin.overview.helpHttpErrorChart' | adminTranslate"
            [valueSuffix]="'admin.common.errorsPerMinuteUnit' | adminTranslate"
            [expandLabel]="'admin.overview.expandChart' | adminTranslate"
            [series]="serviceHttpErrorChartSeries"
            (expandChart)="openGlobalChartModal('http-errors')">
          </ui-metric-line-chart>

          <ui-metric-line-chart
            [title]="'admin.overview.httpLatencyChart' | adminTranslate"
            [subtitle]="'admin.overview.httpLatencyChartHint' | adminTranslate"
            [emptyLabel]="'admin.overview.noChartData' | adminTranslate"
            [infoTooltip]="'admin.overview.helpHttpLatencyChart' | adminTranslate"
            [valueSuffix]="'admin.common.msUnitWithLeadingSpace' | adminTranslate"
            [expandLabel]="'admin.overview.expandChart' | adminTranslate"
            [series]="serviceHttpLatencyChartSeries"
            (expandChart)="openGlobalChartModal('http-latency')">
          </ui-metric-line-chart>
        </div>
      }

      @if (infra.pods?.length) {
        <div class="pod-table">
          <div class="pod-table__head">
            <span>{{ 'admin.overview.pod' | adminTranslate }}</span>
            <span>{{ 'admin.overview.component' | adminTranslate }}</span>
            <span>{{ 'admin.overview.status' | adminTranslate }}</span>
            <span>{{ 'admin.overview.cpu' | adminTranslate }}</span>
            <span>{{ 'admin.overview.memory' | adminTranslate }}</span>
            <span>{{ 'admin.overview.restarts' | adminTranslate }}</span>
          </div>
          @for (pod of infra.pods; track trackPod($index, pod)) {
            <article class="pod-row">
              <span>
                <strong>{{ pod.name }}</strong>
                <small>{{ pod.nodeName || ('admin.common.notAvailable' | adminTranslate) }}</small>
              </span>
              <span>{{ pod.component }}</span>
              <span [class]="infrastructureStatusClass(pod.healthStatus)">{{ pod.healthStatus }}</span>
              <span>{{ formatCpuMilli(pod.cpuMilliCores) }}</span>
              <span>{{ formatBytes(pod.memoryBytes) }}</span>
              <span>{{ pod.restartCount }}</span>
            </article>
          }
        </div>
      }
    }
  </div>

  @if (!isMonitoringMode) {
    <div class="section-block">
      <div class="section-block__header">
        <h3>{{ 'admin.overview.recentIncidents' | adminTranslate }}</h3>
        @if (data.recentFailedAuditEvents.length) {
          <ui-button variant="secondary" size="sm" [routerLink]="['/audit']" [queryParams]="{ success: 'false' }">{{ 'admin.overview.viewFailedAudit' | adminTranslate }}</ui-button>
        }
      </div>

      @if (data.recentFailedAuditEvents.length) {
        <div class="incident-list">
          @for (event of data.recentFailedAuditEvents; track event.id) {
            <article class="incident-card">
              <div>
                <strong>{{ actionLabel(event.actionType) }}</strong>
                <p>{{ event.reason || ('admin.overview.noReason' | adminTranslate) }}</p>
                <small>{{ event.occurredAt | date:'dd/MM/yyyy HH:mm' }}</small>
              </div>
              <div class="incident-card__actions">
                @if (event.effectiveUserId) {
                  <a class="ghost-link" [routerLink]="['/users', event.effectiveUserId]">{{ 'admin.common.account' | adminTranslate }}</a>
                }
                <a class="ghost-link" [routerLink]="['/audit', event.id]">{{ 'admin.common.detail' | adminTranslate }}</a>
              </div>
            </article>
          }
        </div>
      } @else {
        <p class="empty">{{ 'admin.overview.noRecentIncidents' | adminTranslate }}</p>
      }
    </div>
  }

  @if (chartModal; as modal) {
    <div
      class="chart-modal-backdrop"
      (click)="closeChartModal()"
      role="button"
      tabindex="0"
      (keydown.escape)="closeChartModal()"
      [attr.aria-label]="'admin.common.close' | adminTranslate">
    </div>
    <div class="chart-modal" role="dialog" aria-modal="true" aria-labelledby="chart-modal-title">
      <div class="chart-modal__content">
        <div class="chart-modal__header">
          <div>
            <h2 id="chart-modal-title" class="chart-modal__title">{{ modal.title }}</h2>
            <p class="chart-modal__subtitle">{{ modal.subtitle }}</p>
          </div>
          <button
            type="button"
            class="chart-modal__close"
            (click)="closeChartModal()"
            [attr.aria-label]="'admin.common.close' | adminTranslate">
            &times;
          </button>
        </div>

        <div class="history-controls history-controls--modal">
          <div class="history-range-control-group">
            <ui-time-range-picker
              [presets]="historyRangeOptions"
              [quickPresets]="historyQuickRangeOptions"
              [value]="chartModalRangePickerValue"
              [labels]="timeRangePickerLabels"
              [locale]="timeRangePickerLocale"
              (valueChange)="applyChartModalRangePickerValue($event)">
            </ui-time-range-picker>
          </div>
        </div>

        @if (modal.loading) {
          <p class="empty">{{ 'admin.overview.loading' | adminTranslate }}</p>
        } @else {
          <ui-metric-line-chart
            [title]="modal.title"
            [subtitle]="modal.subtitle"
            [emptyLabel]="'admin.overview.noChartData' | adminTranslate"
            [infoTooltip]="modal.infoTooltip"
            [valueSuffix]="modal.valueSuffix"
            [expandable]="false"
            [aggregationIntervalMs]="modal.selectedAggregationIntervalMs"
            [rangeStart]="chartModalHistoryRangeStart"
            [rangeEnd]="chartModalHistoryRangeEnd"
            [rangePickerValue]="chartModalRangePickerValue"
            [series]="chartModalSeries"
            (aggregationIntervalChange)="onChartModalAggregationIntervalChange($event)"
            (rangePickerValueChange)="applyChartModalRangePickerValue($event)">
          </ui-metric-line-chart>
        }
      </div>
    </div>
  }
} @else if (loading) {
  <p class="empty">{{ 'admin.overview.loading' | adminTranslate }}</p>
}

